import { render, staticRenderFns } from "./SessionInactivityModal.vue?vue&type=template&id=55c4c5f8&scoped=true"
import script from "./SessionInactivityModal.vue?vue&type=script&lang=js"
export * from "./SessionInactivityModal.vue?vue&type=script&lang=js"
import style0 from "./SessionInactivityModal.vue?vue&type=style&index=0&id=55c4c5f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c4c5f8",
  null
  
)

export default component.exports